// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging } from "firebase/messaging";

// Replace with your actual Firebase config
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAS6eYW4c4yprxFboQNYx-4-3kQpNBXr8g",
  authDomain: "eascode-prod.web.app",
  projectId: "eascode-prod",
  storageBucket: "eascode-prod.firebasestorage.app",
  messagingSenderId: "909855612556",
  appId: "1:909855612556:web:2ed866085160b9cf6225a9",
  measurementId: "G-CSYXJM6SPM"
};

const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

// Initialize App Check with your reCAPTCHA v3 Site Key
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LcenRctAAAAAGxD1jeuXB14G-XhBD9Bp95TP7mV'), // 👈 Use the "Site Key" from reCAPTCHA admin
  isTokenAutoRefreshEnabled: true // Automatically refreshes tokens in the background
});

let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

const messaging = getMessaging(app);

// 3. Initialize Functions and export it
const functions = getFunctions(app);

// Export everything so your pages can use them
export { app, appCheck, functions };

// Export Firebase services
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore("default");
export const storage = getStorage(app);
export {messaging}
export {analytics}